module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "scroll-bottom",
      rawName: "v-scroll-bottom",
      value: (_vm.messages),
      expression: "messages"
    }],
    staticClass: "message"
  }, [(_vm.realmessages) ? _c('ul', _vm._l((_vm.realmessages), function(item) {
    return _c('li', [(item.createDT) ? _c('p', {
      staticClass: "time"
    }, [_c('span', [_vm._v(_vm._s(item.createDT))])]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "main",
      class: {
        self: item.messageType === 1
      }
    }, [_c('img', {
      staticClass: "avatar",
      attrs: {
        "width": "30",
        "height": "30",
        "src": item.messageType === 1 ? '/emktResources/resocurces/img/user.jpg' : '/emktResources/resocurces/img/customerService.jpeg'
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "text"
    }, [_vm._v(_vm._s(item.message) + " "), (item.merchandise) ? _c('a', {
      attrs: {
        "href": '#/detail/merchandises?id=' + item.merchandise.merchandiseId
      }
    }, [_vm._v(_vm._s(item.merchandise.merchandiseLabel))]) : _vm._e()])])])
  }), 0) : _c('ul', _vm._l((_vm.messages), function(item) {
    return _c('li', [(item.createDT) ? _c('p', {
      staticClass: "time"
    }, [_c('span', [_vm._v(_vm._s(item.createDT))])]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "main",
      class: {
        self: item.messageType === 1
      }
    }, [_c('img', {
      staticClass: "avatar",
      attrs: {
        "width": "30",
        "height": "30",
        "src": item.messageType === 1 ? '/emktResources/resocurces/img/user.jpg' : '/emktResources/resocurces/img/customerService.jpeg'
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "text"
    }, [_vm._v(_vm._s(item.message) + " "), (item.merchandise) ? _c('a', {
      attrs: {
        "href": '#/detail/merchandises?id=' + item.merchandise.merchandiseId
      }
    }, [_vm._v(_vm._s(item.merchandise.merchandiseLabel))]) : _vm._e()])])])
  }), 0)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-c4dba01e","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/Message/MessageContent.vue
// module id = 1719
// module chunks = 8